import { useEffect, useState } from 'react';

/**
 * Useful when you want to build something responsive in JSX.
 */
export default function useWindowWidth(): number {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.innerWidth);

  useEffect(() => {
    setWidth(window.innerWidth);
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return width;
}
